<!--
@component
Logo

See markup below.
-->

<script lang="ts">
  import getPath from '$utils/getPath';
  import settings from '$lib/config/settings.json';
  import { page } from '$app/state';

  // Tournament-specific labels come from content (see `content.tournamment`
  // in `locales/en/content.json`). The active tournament key is a one-time
  // build setting in `src/lib/config/settings.json` — read directly here,
  // since it doesn't change while the app is running.
  const tournament = settings.tournament.type as 'wc' | 'euro';
  const label = $derived(page.data?.content?.tournamment?.[tournament]);
  const iconSrc = $derived(getPath(`images/icons/${label?.iconFile}`));
</script>

<div class="logo flex justify-center items-center">
  <div class="label {label.key} uppercase text-center leading-tighter text-sm">
    <div class="game font-black">{label.game}</div>
    <div class="venue">{label.venue}</div>
  </div>
  <div class="icon">
    <img class="fmy-0 fmx-1" src={iconSrc} alt="" aria-hidden="true" />
  </div>
</div>

<style lang="scss">
  .logo {
    height: 100%;
    width: 200px;
    .game {
      color: var(--theme-colour-logo);
    }
    .venue {
      color: var(--theme-colour-text-secondary);
      font-weight: 400;
    }
  }

  img {
    width: var(--theme-font-size-2xl);
    height: auto;
  }

  /* EURO specific styles */
  .label.euro {
    .venue {
      letter-spacing: 0.1em;
    }
  }

  /* World Cup specific styles */
  .label.wc {
    .venue {
      letter-spacing: 0em;
      font-size: var(--theme-font-size-xxs);
    }
  }
</style>
